
import { Button } from "@/components/ui/button";
import {
  Card,
  CardFooter,
  CardHeader,
  CardTitle,
  CardDescription,
  CardContent,
} from "keep-react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { closeRegisterModal, openLoginModal } from "@store/features/userActionsSlice";
import { selectBrandString } from "@store/features/styleSchemaSlice";

export function LoginCard() {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const brandString = useSelector(selectBrandString);
    const handleOpenLogin = () => {
        dispatch(closeRegisterModal());
        dispatch(openLoginModal());
      };
  return (
    <div className="flex items-center justify-center w-full gap-4 bg-white">
      <div className="shadow-lg w-full md:w-1/2 max-w-3xl rounded-xl">
          <Card className="p-4 w-full max-w-full border-none">
            <CardHeader>
              <CardTitle className="text-center">{t("landing.loginCard.title", { brandString })}</CardTitle>
            </CardHeader>
            <CardDescription className="text-center">{t("landing.loginCard.description")}</CardDescription>
            <CardContent>
            </CardContent>
            <CardFooter className="flex justify-center">
              <Button onClick={handleOpenLogin} className="text-white">{t("landing.loginCard.button")}</Button>
            </CardFooter>
          </Card>
      </div>
    </div>
  );
}
